// src/components/Requiremts.js
import React from "react";

const Requirements = () => {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="mb-12 text-3xl md:text-4xl font-semibold leading-10 text-center tracking-tight flex justify-center">
        Rental Policies and Requirements
      </h1>
      <ol className="list-decimal list-inside space-y-10 text-base font-medium leading-7 text-white text-justify">
        <li>
          Please check the vehicles section to see the mileage allowance for
          your rental.
        </li>
        <li>
          Once a reservation with LA Exotic Autos Enterprise is made, 100% payment
          is due to hold the date(s)/car(s). There is no penalty for
          cancellation or rescheduling up to 24 hours before the rental date.
          There will be a penalty of 50% of the total rental cost if the rental
          is canceled less than 24 hours prior to the rental. This is due to
          potential loss of rental we incur.
        </li>
        <li>
          If you cancel by emailing info@bluediamondenterprise.net or by
          contacting us directly within 24 hours of creating your reservation,
          you can receive a refund back to the original form of payment or
          choose to convert the reservation fare into a credit to be used toward
          future reservations. If you are canceling after 24 hours your
          reservation LA Exotic Autos Enterprise does not provide refunds. However,
          there are no cancellation fees. We will hold your payment as credit up
          to (1) month from the date of the original payment at which time it
          will expire.
        </li>
        <li>
          Rental extensions and credits depend on availability and approval by
          LA Exotic Autos Enterprise.
        </li>
        <li>
          All drivers must be 21 years and older with a valid driver’s license
          and clean driving record (no major moving violations, DUI convictions,
          or similar infractions).
        </li>
        <li>
          Customers are required to have their own full-coverage insurance
          (liability, comprehensive, collision and loss of use) and to send a
          declaration page of their insurance coverage to us by email. One of
          LA Exotic Autos employees will verify with your insurance company if that
          coverage will transfer over to the vehicle being rented. Each driver
          is required to provide their own car insurance that covers up to:
          <ul className="list-disc list-inside ml-6">
            <li>$25,000 Bodily Injury Liability per person</li>
            <li>$50,000 Bodily Injury per accident</li>
            <li>$10,000 Property Damage Liability</li>
          </ul>{" "}
          Also have full comprehensive & collision coverage (If not you may
          visit our website's booking page to explore other available insurance
          options.)
        </li>
        <li>
          Additional drivers may be listed as authorized drivers. Additional
          drivers may be listed on your Rental Agreement (additional charge may
          apply). Each additional driver must submit a driver’s license in
          advance and must have the above qualifications (age, licensing and
          good driving-record, valid insurance coverage, etc).
        </li>
      </ol>
    </div>
  );
};

export default Requirements;
